import React, { useState } from "react";
import { Popover, Tag } from "antd";
import { SketchPicker } from "react-color";

function Series(props: any) {
  const [color, setColor] = useState("rgb(190, 44, 44)");

  const handleSwitchBarColor = (color: any) => {
    const copy = JSON.parse(JSON.stringify(props.optionSource));
    const newSeries = copy.series.map((s: any) => {
      if (s.name === props.name) {
        s.color = color.hex;
      }
      return s;
    });
    copy.series = newSeries;
    console.log(copy);
    setColor(color.hex);
    props.setOption(copy);
    props.setOptionSource(copy);
  };
  return (
    <div style={{ margin: "5px 5px" }}>
      {props.name + " - "}
      <Popover
        placement="leftTop"
        title={"柱体颜色"}
        content={
          <SketchPicker
            color={color}
            onChangeComplete={handleSwitchBarColor}
          ></SketchPicker>
        }
        trigger="click"
      >
        <Tag color={color} style={{ cursor: "pointer" }}>
          柱体颜色
        </Tag>
      </Popover>
    </div>
  );
}

export default Series;
